/**
 * What a step card shows ops: one state, one badge, one set of controls. Derived on the server
 * (src/lib/step-cards/derive.ts) from the card's workflow steps, the task's status and ops' verdict,
 * so the page renders it as given.
 */
export enum StepCardState {
  /** None of the card's work has run, or what remains hasn't, and nothing is running it now. */
  NOT_RUN = "not_run",
  /** Automation is working on the card's steps, including automatic retries still in flight. */
  PROCESSING = "processing",
  /** The card's work didn't apply to this task: each of its steps was marked not needed. */
  NOT_NEEDED = "not_needed",
  /** The run waits on this card for ops: its approval to decide, or a parked step to resume. */
  ACTION_NEEDED = "action_needed",
  /** Automation should have done the work and didn't. A failure is engineering's; ops has no action on it. */
  FAILED = "failed",
  /**
   * The card's work is done: automation finished it, or ops answered what it held. Ops may still
   * spot-check automation's result with ✓ / ✗, but the run never waits for that.
   */
  COMPLETED = "completed",
  /** Ops marked automation's result Incorrect (✗, saying why), or rejected the approval it held. */
  INCORRECT = "incorrect",
}

/**
 * States in which a presented card asks ops for something: what the run waits on, or a fix by hand.
 * A card also asks while it offers an action, ✓ / ✗ included.
 */
export const STEP_CARD_STATES_ASKING_OPS: ReadonlySet<StepCardState> = new Set([
  StepCardState.ACTION_NEEDED,
  StepCardState.INCORRECT,
]);
